import { useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hover: {
      opacity: theme.palette.mode === 'light' ? '0.6' : '1.0',
      '-webkit-filter': theme.palette.mode === 'light' ? 'brightness(1.0)' : 'brightness(1.3)',
      '-moz-filter': theme.palette.mode === 'light' ? 'brightness(1.0)' : 'brightness(1.3)',
      '-o-filter': theme.palette.mode === 'light' ? 'brightness(1.0)' : 'brightness(1.3)',
      '-ms-filter': theme.palette.mode === 'light' ? 'brightness(1.0)' : 'brightness(1.3)',
    },
    noHover: {},
  })
)

export const useHoverOpacity = () => {
  const [hovered, setHovered] = useState(false)
  const classes = useStyles()

  return {
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    hoverClass: hovered ? classes.hover : classes.noHover,
  }
}
